import React, { useEffect, useState } from "react";
import {
  Checkbox,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import { Inactive, Unmaped, Active } from "../../shared/ActivaInactive";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const Configuration = () => {
  const [data, setData] = useState({});
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("");
  const [value1, setValue1] = useState("");
  const [host, setHost] = useState("");
  const [Port, setPort] = useState("");
  const [User, setUser] = useState("");
  const [Psw, setPsw] = useState("");

  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);
  const storeId = localStorage.getItem("store_id");

  const editFunctionality = (event, row) => {
    event.preventDefault();
    handleOpen1();
    setRowData(row);
    setIds(row?.id);
    setValue(row?.use_tls);
    setValue1(row?.fail_silently);
    setStatus(row?.active_status);
    setHost(row?.host);
    setPort(row?.port);
    setUser(row?.username);
    setPsw(row?.password);
  };

  const handleModalClose = () => {
    setIds(null);
    setValue("");
    setValue1("");
    setStatus("");
    setHost("");
    setUser("");
    setPsw("");
    setPort("");
    handleClose1();
  };

  const emailDataList = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/email-configuration-store/?store_id=${storeId}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.settingemailconfiguration);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    emailDataList();
  }, []);

  const emailCreate = () => {
    const reqbody = new FormData();
    reqbody.append("use_tls", value);
    reqbody.append("fail_silently", value1);
    reqbody.append("host", host);
    reqbody.append("port", Port);
    reqbody.append("username", User);
    reqbody.append("password", Psw);
    reqbody.append("active_status", status);
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/email-configuration-store/?store_id=${storeId}`,
        reqbody,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message);
        setRowData({});
        setValue("");
        setValue1("");
        setStatus("");
        setHost("");
        setUser("");
        setPsw("");
        handleClose1();
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">Email Setting</p>
        </div>{" "}
        <div className="p-2">
          <Button variant="outlined" size="small" onClick={handleOpen1}>
            ADD NEW EMAIL
          </Button>
          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box
              sx={{ ...style, width: 850 }}
              className="rounded-2xl !border-0"
            >
              <div
                id="child-modal-title "
                className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
              >
                {ids === null ? "Add Email" : "Update Email"}
              </div>
              <div className="flex justify-between">
                <div className="w-[48%]">
                  <div className="">User Name</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    value={User}
                    onChange={(event) => setUser(event.target.value)}
                  />
                  <div className="mt-2">User TLS :</div>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={"" || value}
                      onChange={(event) => setValue(event.target.value)}
                    >
                      <FormControlLabel
                        value="true"
                        control={<Radio color="success" />}
                        label="True"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio color="success" />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                  <div className="mt-2">Host :</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    value={host}
                    onChange={(event) => setHost(event.target.value)}
                  />

                  <div className="mt-2">Status :</div>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={status}
                    onChange={(event) => setStatus(event.target.value)}
                    >
                      <FormControlLabel
                        value="true"
                        control={<Radio color="success" />}
                        label="True"

                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio color="success"/>}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="w-[48%]">
                  <div className="">Password</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    value={Psw}
                    onChange={(event) => setPsw(event.target.value)}
                  />
                  <div className="mt-2"> Fail Silently :</div>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={value1}
                      onChange={(event) => setValue1(event.target.value)}
                    >
                      <FormControlLabel
                        value="true"
                        control={<Radio color="success" />}
                        label="True"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio color="success" />}
                        label="False"
                      />
                    </RadioGroup>
                  </FormControl>

                  <div className="mt-2">Port :</div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-3"
                    value={Port}
                    onChange={(event) => setPort(event.target.value)}
                  />
                </div>
              </div>
              <Button
                onClick={handleModalClose}
                variant="contained"
                color="warning"
                className="!py-2 !mt-3"
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                type="submit"
                color="success"
                className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                onClick={emailCreate}
              >
                {ids === null ? "Add" : "UPDATE"}
              </Button>
            </Box>
          </Modal>
        </div>{" "}
      </div>

      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex justify-between my-3">
          <span className="flex  gap-3"></span>
          <span>
            <div className="text-red-500 mx-3">
              {/* <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Store
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select Store"
                  className="w-72"
                  size="small"
                  onChange={(event) => setFindStoreID(event.target.value)}
                >
                  {storeData?.map((item) => (
                    <MenuItem value={item?.id}>{item?.store_name}</MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Store
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  use_tls
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  fail_silently
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  host
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  username
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Password
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Port
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Status
                </TableCell>

                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              <TableRow className="!text-slate-700">
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.id}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.store?.store_name}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  <div className="flex justify-center w-full p-4">
                    {data?.use_tls === null ? (
                      <Unmaped />
                    ) : data?.use_tls === true ? (
                      <Active />
                    ) : (
                      <Inactive />
                    )}
                  </div>
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {" "}
                  <div className="flex justify-center w-full p-4">
                    {data?.fail_silently === null ? (
                      <Unmaped />
                    ) : data?.fail_silently === true ? (
                      <Active />
                    ) : (
                      <Inactive />
                    )}
                  </div>
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.host}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.username}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.password}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.port}
                </TableCell>

                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  <div className="flex justify-center w-full p-4">
                    {data?.active_status === null ? (
                      <Unmaped />
                    ) : data?.active_status === true ? (
                      <Active />
                    ) : (
                      <Inactive />
                    )}
                  </div>
                </TableCell>

                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  <div>
                    <div>
                      <BorderColorIcon
                        className="text-green-400"
                        onClick={(event) => editFunctionality(event, data)}
                      />
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Configuration;
